import request from '@/utils/request';

export function getByBarcode(barcode) {
  return request({
    params: barcode,
    method: 'get',
    url: 'orderline/barcode'
  });
}

export function quickSearch(searchQuery) {
  return request({
    params: searchQuery,
    method: 'get',
    url: 'orderline/quicksearch'
  });
}

export function printTicket(printCommand) {
  const url = `orderline/print`;
  return request({
    data: printCommand,
    method: 'post',
    url: url
  });
}

export function createReturnOrderLine(dto) {
  const url = `orderline/createreturnorderline`;
  return request({
    data: dto,
    method: 'post',
    url: url
  });
}

export function getPage(filters) {
  const url = `orderline/page`;
  return request({
    params: filters,
    method: 'get',
    url: url
  });
}

export function count(filters) {
  const url = `orderline/count`;
  return request({
    params: filters,
    method: 'get',
    url: url
  });
}

function transformItem2Dto(item) {
  const dto = {
    ...item,
    orderLineID: item.id
  };
  delete dto.id;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.orderLineID
  };
  delete item.orderLineID;
  return item;
}

export const storeExtensions = {
  actions: {
    getByBarcode({ commit, dispatch }, barcode) {
      return new Promise((resolve, reject) =>
        getByBarcode(barcode)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    quickSearch({ commit, dispatch }, searchQuery) {
      return new Promise((resolve, reject) =>
        quickSearch(searchQuery)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    printProductionTicket({ commit, dispatch }, printCommand) {
      return new Promise((resolve, reject) =>
        printTicket(printCommand)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    createReturnOrderLine({ commit, dispatch }, dto) {
      return new Promise((resolve, reject) =>
        createReturnOrderLine(dto)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getPage({ commit, dispatch }, { filters }) {
      return new Promise((resolve, reject) =>
        getPage(filters)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    count({ commit, dispatch }, { filters }) {
      return new Promise((resolve, reject) =>
        count(filters)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};

export const apiOverrides = { transformItem2Dto, transformDto2Item };
